import React, { useEffect, useRef, useState } from "react";
import PropType from "prop-types";
import {
  Button,
  // Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Image,
  Input,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { Link, useHistory, useParams } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { isEmpty } from "lodash";
import "./auth.css";
import logo from "../../assets/images/Logo copy.png";
// import registerLogo from "../../assets/images/Logo.jpg";
import { emailIsValid } from "./validations";
// import { useDispatch } from "react-redux";
// import { signUp } from "../../store/auth/actions";
// import moment from "moment/moment";
import api, { setAuthToken } from "../../helpers";

const Register = (props) => {
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const history = useHistory();
  // const dispatch = useDispatch();

  // const stateValues = useSelector((state) => state.Auth);

  // console.log(stateValues, "stateValues");
  //State values section
  const [source, setSource] = useState([]);
  const [Occupation, setOccupation] = useState([]);
  const [gender, setGender] = useState([]);
  const [error, setError] = useState(false);
  const [dob, setDob] = useState("");
  const [anniversary, setAnniversary] = useState("");
  const [registerData, setRegisterData] = React.useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    Occupation: "",
    secretKey: "",
  });

  const mobileNo = localStorage.getItem("mobileNo");
  const rewards = localStorage.getItem("reward");

  const reward = rewards && JSON.parse(rewards);

  // const { id } = useParams();

  console.log(reward, "reward");
  useEffect(() => {
    if (!isEmpty(mobileNo)) {
      setRegisterData({
        ...registerData,
        mobile: mobileNo,
      });
    } else {
      setRegisterData({
        ...registerData,
        mobile: "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mobileNo]);

  //Email validation changes
  const validationChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-input");
    const current_value = inputValue.replace(/ /g, "");
    setRegisterData({ ...registerData, email: current_value });

    if (!emailIsValid(current_value)) {
      document.getElementById("error-panel").style.display = "block";
      mainInput.value = current_value;
    } else {
      document.getElementById("error-panel").style.display = "none";
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      mobile: /^[0-9]*$/,
      secretKey: /^[0-9]*$/,
    };
    if (validationRules[name]) {
      if (validationRules[name].test(value) || value === "") {
        setRegisterData({
          ...registerData,
          [name]: value,
        });
      }
    } else {
      setRegisterData({
        ...registerData,
        [name]: value,
      });
    }
  };
  // console.log(registerData, source, "state values");
  console.log(dob, anniversary, "date values");
  //validations

  const registerFinalSubmit = () => {
    if (simpleValidator.current.allValid()) {
      if (reward.status_code === 200) {
        const user = {
          first_name: registerData.firstName,
          last_name: registerData.lastName,
          mobile: registerData.mobile,
          email: registerData.email,
          dob: !isEmpty(dob) ? dob : "",
          gender: gender,
          anniversary_date: !isEmpty(anniversary) ? anniversary : "",
          source: source,
          occupation: Occupation,
          lpin: registerData.secretKey,
          referral_link_code: reward.data.referral_link_code,
          referral_link_id: reward.data.referral_link_id,
        };
        api
          .post("/Api/member_register", user)
          .then((res) => {
            console.log(res.data, "response in register");
            localStorage.setItem("sessionUser", JSON.stringify(res));
            localStorage.setItem("authUser", res.data.data);
            setAuthToken(res.data && res.data.data && res.data.data.token);
            history.push("/dashboard");
            return res.data;
          })
          .catch((error) => {
            setError(error);
            return Promise.reject(error);
          });
      } else {
        const user = {
          first_name: registerData.firstName,
          last_name: registerData.lastName,
          mobile: registerData.mobile,
          email: registerData.email,
          dob: !isEmpty(dob) ? dob : "",
          gender: gender,
          anniversary_date: !isEmpty(anniversary) ? anniversary : "",
          source: source,
          occupation: Occupation,
          lpin: registerData.secretKey,
        };
        api
          .post("/Api/member_register", user)
          .then((res) => {
            console.log(res.data, "response in register");
            localStorage.setItem("sessionUser", JSON.stringify(res));
            localStorage.setItem("authUser", res.data.data);
            history.push("/dashboard");
            return res.data;
          })
          .catch((error) => {
            setError(error);
            return Promise.reject(error);
          });
      }

      // dispatch(signUp(user));
      // console.log(user, "user");
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const loginPagePath =
    !isEmpty(reward) && reward.data
      ? `/login/${reward.data.referral_link_code}`
      : "/login/#";

  return (
    <div
      className="flex-container"
      style={{
        overflow: "hidden",
      }}
    >
      <Card
        style={{
          flex: "1",
        }}
        className="login-card"
      >
        <div className="login-image flex justify-center">
          <div className="mt-[75px] bg-[transparent]">
            {/* <Image
              src={logo}
              preview={false}
              width={180}
              height={70}
              className="rounded-lg"
            /> */}
            <div className="mt-2">
              <h1
                style={{
                  padding: "7px",
                  borderRadius: "10px",
                  border: "none",
                  background: "#69000070",
                  // boxShadow: "1px 1px 13px 1px #8d8d8d8f",
                }}
                className="text-[20px] font-bold text-[#ffffff]"
              >
                A Loyalty Program that pays you back
              </h1>
            </div>
          </div>

          {/* <Image
            src={logoOverlay}
            preview={false}
            className="logo-overlay"
          /> */}
        </div>
      </Card>

      <Card
        style={{
          flex: "1",
          margin: "0px 0px",

          width: "100%",
          height: "auto",
          overflow: "hidden",
        }}
        className="register-form-card"
      >
        <div
          className="font-sans"
          style={{
            margin: "0px 35px",
            marginTop: "10px",
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <Image
            src={logo}
            preview={false}
            style={{
              alignContent: "flex-start",
              width: "150px",
              height: "80px",
              borderRadius: "2px",
            }}
          />
        </div>
        <div className="w-[100] text-center text-[red]">
          {!isEmpty(error) ? error.response.data.message : ""}
        </div>
        <Form
          className="custom-form"
          style={{ marginTop: "25px", marginLeft: "32px", marginRight: "28px" }}
        >
          <Row gutter={[16, 4]}>
            <Col lg={12} xl={12} md={24} sm={24} xs={24}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "10px" }}
              >
                <Input
                  placeholder=""
                  name="firstName"
                  onChange={handleChange}
                  value={registerData.firstName}
                  style={{
                    width: "100%",
                    height: "45px",
                    backgroundColor: "#f1f1f1",
                  }}
                />
                <label
                  style={{
                    backgroundColor: "#f1f1f1",
                    fontSize: "14px",
                    color: "GrayText",
                  }}
                >
                  First Name
                </label>
                <p className="text-start text-[#ef3022] text-[12px] mt-1">
                  {simpleValidator.current.message(
                    "firstName",
                    registerData.firstName,
                    "required"
                  )}
                </p>
              </Form.Item>
            </Col>
            <Col lg={12} xl={12} md={24} sm={24} xs={24}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "10px" }}
              >
                <Input
                  placeholder=" "
                  onChange={handleChange}
                  name="lastName"
                  value={registerData.lastName}
                  style={{ width: "100%", marginRight: "35px", height: "45px" }}
                  variant="borderless"
                />
                <label
                  style={{
                    marginLeft: "5px",
                    backgroundColor: "#f1f1f1",
                    color: "GrayText",

                    fontSize: "14px",
                  }}
                >
                  {" "}
                  Last Name
                </label>
                <p className="text-start text-[#ef3022] text-[12px] mt-1">
                  {simpleValidator.current.message(
                    "lastName",
                    registerData.lastName,
                    "required"
                  )}
                </p>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 4]}>
            <Col lg={12} xl={12} md={24} sm={24} xs={24}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "10px" }}
              >
                <Input
                  placeholder=" "
                  name="mobile"
                  onChange={handleChange}
                  value={registerData.mobile}
                  disabled={!isEmpty(mobileNo) ? true : false}
                  maxLength={10}
                  style={{ width: "100%", height: "45px" }}
                  variant="borderless"
                />
                <label
                  style={{
                    backgroundColor: "#f1f1f1",
                    fontSize: "14px",
                    color: "GrayText",
                  }}
                >
                  Mobile
                </label>
                <p className="text-start text-[#ef3022] text-[12px] mt-1">
                  {simpleValidator.current.message(
                    "mobile",
                    registerData.mobile,
                    "required"
                  )}
                </p>
              </Form.Item>
            </Col>
            <Col lg={12} xl={12} md={24} sm={24} xs={24}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "10px" }}
              >
                <Input
                  placeholder=" "
                  name="email"
                  id="main-input"
                  onChange={validationChange}
                  value={registerData.email}
                  style={{ width: "100%", marginRight: "35px", height: "45px" }}
                  variant="borderless"
                />
                <label
                  style={{
                    marginLeft: "5px",
                    backgroundColor: "#f1f1f1",
                    color: "GrayText",
                    fontSize: "14px",
                  }}
                >
                  Email
                </label>
                <p className="text-start text-[#ef3022] text-[12px] mt-1">
                  {simpleValidator.current.message(
                    "email",
                    registerData.email,
                    "required"
                  )}
                </p>
                <div
                  id="error-panel"
                  style={{
                    display: "none",
                    marginBottom: "10px",
                  }}
                >
                  {isEmpty(registerData.email) ? (
                    ""
                  ) : (
                    <p className="text-start text-[#ff0000]">
                      The email or mobile field is not valid
                    </p>
                  )}
                </div>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 4]}>
            <Col lg={12} xl={12} md={24} sm={24} xs={24}>
              <Form.Item style={{ marginBottom: "15px" }}>
                <DatePicker
                  placeholder="Date of Birth"
                  className="custom-DatePicker"
                  placement="bottom left"
                  popupClassName="min-h-[30%]"
                  onChange={(date, dateString, id) => {
                    console.log(date, dateString, id, "date");
                    if (dateString) {
                      setDob(dateString);
                    } else {
                      setDob("");
                    }
                  }}
                  // variant='Borderless'
                  style={{
                    width: "100%",
                    height: "45px",
                    marginLeft: "2px",
                    backgroundColor: "#f1f1f1",
                    fontWeight: 600,
                  }}
                />
                {/* <p className="text-start text-[#ef3022] text-[12px] mt-1">
                  {simpleValidator.current.message("dob", dob, "required")}
                </p> */}
                {/* <label>Date of Birth</label> */}
              </Form.Item>
            </Col>
            <Col lg={12} xl={12} md={24} sm={24} xs={24}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "10px" }}
              >
                <Select
                  allowClear
                  placeholder=""
                  variant="borderless"
                  value={gender}
                  onChange={(e) => setGender(e)}
                  style={{
                    width: "100%",
                    height: "45px",
                    marginRight: "45px",
                    backgroundColor: "#f1f1f1",
                  }}
                  options={[
                    { value: "Male", label: "Male" },
                    { value: "Female", label: "Female" },
                    { value: "Others", label: "Others" },
                  ]}
                />
                {!isEmpty(gender) ? (
                  ""
                ) : (
                  <label
                    style={{
                      marginLeft: "5px",
                      backgroundColor: "#f1f1f1",
                      color: "GrayText",
                      fontSize: "14px",
                    }}
                  >
                    Gender
                  </label>
                )}

                <p className="text-start text-[#ef3022] text-[12px] mt-1">
                  {simpleValidator.current.message(
                    "gender",
                    gender,
                    "required"
                  )}
                </p>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 4]}>
            <Col lg={12} xl={12} md={24} sm={24} xs={24}>
              <Form.Item style={{ marginBottom: "15px" }}>
                <DatePicker
                  placeholder="Anniversary"
                  placement="topRight"
                  popupClassName="h-[80px]"
                  onChange={(date, dateString) => {
                    console.log(date, dateString);

                    setAnniversary(dateString);
                  }}
                  style={{
                    width: "100%",
                    height: "45px",
                    marginLeft: "3px",
                    backgroundColor: "#f1f1f1",
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                />
                {/* <p className="text-start text-[#ef3022] text-[12px] mt-1">
                  {simpleValidator.current.message(
                    "anniversary",
                    anniversary,
                    "required"
                  )}
                </p> */}
              </Form.Item>
            </Col>
            <Col lg={12} xl={12} md={24} sm={24} xs={24}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "10px" }}
              >
                <Select
                  allowClear
                  placeholder=""
                  variant="borderless"
                  value={source}
                  onChange={(e) => setSource(e)}
                  style={{
                    width: "100%",
                    height: "45px",
                    marginRight: "45px",
                    backgroundColor: "#f1f1f1",
                  }}
                  options={[
                    { value: "Facebook", label: "Facebook" },
                    { value: "Instagram", label: "Instagram" },
                    { value: "Friends", label: "Friends" },
                    { value: "Relatives", label: "Relatives" },
                  ]}
                />
                {!isEmpty(source) ? (
                  ""
                ) : (
                  <label
                    style={{
                      marginLeft: "5px",
                      backgroundColor: "#f1f1f1",
                      color: "GrayText",
                      // marginLeft: "-3px",
                      fontSize: "14px",
                    }}
                  >
                    Source
                  </label>
                )}

                <p className="text-start text-[#ef3022] text-[12px] mt-1">
                  {simpleValidator.current.message(
                    "source",
                    source,
                    "required"
                  )}
                </p>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 4]}>
            <Col lg={12} xl={12} md={24} sm={24} xs={24}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "10px" }}
              >
                <Select
                  allowClear
                  placeholder=""
                  variant="borderless"
                  value={Occupation}
                  onChange={(e) => setOccupation(e)}
                  style={{
                    width: "100%",
                    height: "45px",
                    marginRight: "45px",
                    backgroundColor: "#f1f1f1",
                  }}
                  options={[
                    { value: "Student", label: "Student" },
                    { value: "Laborer", label: "Laborer" },
                    { value: "Factory Work", label: "Factory Work" },
                    { value: "Owner-Operator", label: "Owner-Operator" },
                    { value: "Self Employed", label: "Self Employed" },
                    { value: "Homemaker", label: "Homemaker" },
                    { value: "Unemployed", label: "Unemployed" },
                    { value: "Retired", label: "Retired" },
                  ]}
                />
                {!isEmpty(Occupation) ? (
                  ""
                ) : (
                  <label
                    style={{
                      marginLeft: "5px",
                      backgroundColor: "#f1f1f1",
                      color: "GrayText",
                      // marginLeft: "-3px",
                      fontSize: "14px",
                    }}
                  >
                    Occupation
                  </label>
                )}

                {/* <p className="text-start text-[#ef3022] text-[12px] mt-1">
                  {simpleValidator.current.message(
                    "occupation",
                    Occupation,
                    "required"
                  )}
                </p> */}
              </Form.Item>
            </Col>
            <Col lg={12} xl={12} md={24} sm={24} xs={24}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "10px" }}
              >
                <Input.Password
                  placeholder=" "
                  name="secretKey"
                  value={registerData.secretKey}
                  maxLength={4}
                  autoFocus={false}
                  autoSave={false}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    height: "45px",
                    backgroundColor: "#f1f1f1",
                  }}
                />
                <label
                  style={{
                    backgroundColor: "#f1f1f1",
                    fontSize: "14px",
                    color: "GrayText",
                  }}
                >
                  Secret Key
                </label>
                <p className="text-start text-[#ef3022] text-[12px] mt-1">
                  {simpleValidator.current.message(
                    "secretKey",
                    registerData.secretKey,
                    "required"
                  )}
                </p>
              </Form.Item>
            </Col>
          </Row>

          <Space
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginTop: "5px",
              // marginLeft: "2px",
            }}
          >
            <Checkbox style={{ marginRight: "0px" }} />
            <Typography style={{ marginRight: "0px", marginLeft: "-4px" }}>
              I Agree
            </Typography>
            <a href="/creat-account" style={{ color: "#026bb1" }}>
              Terms & Conditions
            </a>
          </Space>

          <Row
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Col span={24}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={() => registerFinalSubmit()}
                  style={{
                    width: "100%",
                    backgroundColor: "#7b7b7b",
                    height: "45px",
                    marginTop: "22px",
                  }}
                >
                  Register
                </Button>
              </Form.Item>
            </Col>
          </Row>
          <div className="register-login-route">
            <Divider className="w-[100%] mb-4">Or</Divider>

            <div className="font-semibold w-[100%] mt-4">
              {/* Existing User ?{" "} */}

              <Link
                to={{
                  pathname: loginPagePath,
                }}
                style={{
                  border: "1px dashed #3498db",
                }}
                className="text-[#3498db] rounded-md p-1 pl-10 pr-10 w-[70%]"
              >
                Login
              </Link>
            </div>
          </div>
        </Form>
      </Card>
    </div>
  );
};

Register.propType = {
  location: PropType.any,
};

export default Register;
